function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import Statement from 'components/Statement';
import messages from '../../messages';
import styles from './Error.pcss';
var _React_PureComponent;
class Error extends (_React_PureComponent = React.PureComponent) {
    get codeName() {
        switch(this.props.code){
            case 403:
                {
                    return 'forbidden';
                }
            case 404:
                {
                    return 'notFound';
                }
            default:
                return 'general';
        }
    }
    renderHeader(title) {
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsxs("p", {
                    className: "text--primary text--medium text-lh--17",
                    children: [
                        /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.errorPage.errorCode)),
                        ": ",
                        this.props.code
                    ]
                }),
                /*#__PURE__*/ _jsx("h1", {
                    className: "text--h1",
                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, title))
                })
            ]
        });
    }
    renderInfoMessage(info, info2) {
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx("span", {
                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, info))
                }),
                info2 && /*#__PURE__*/ _jsx("span", {
                    className: styles.info2,
                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread_props(_object_spread({}, info2), {
                        values: {
                            b: (chunk)=>/*#__PURE__*/ _jsx("b", {
                                    children: chunk
                                }),
                            br: /*#__PURE__*/ _jsx("br", {})
                        }
                    }))
                })
            ]
        });
    }
    renderGoToHomeButton() {
        return /*#__PURE__*/ _jsx("a", {
            href: "/",
            className: "btn btn--primary btn--filled btn--wider mr-4",
            children: /*#__PURE__*/ _jsx("span", {
                className: "btn-inner",
                children: /*#__PURE__*/ _jsx("div", {
                    className: "btn__labelWrapper text--normal",
                    children: /*#__PURE__*/ _jsx("span", {
                        children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.errorPage.goToHomePage))
                    })
                })
            })
        });
    }
    render() {
        const { title, info, info2 } = messages.errorPage[this.codeName];
        const imgSrc = `/bo/assets/svg/illustration/${this.codeName}.svg`;
        return /*#__PURE__*/ _jsx(Statement, {
            headerMessage: this.renderHeader(title),
            imgSrc: imgSrc,
            children: /*#__PURE__*/ _jsxs("div", {
                children: [
                    /*#__PURE__*/ _jsx("p", {
                        className: "mb-8",
                        children: this.renderInfoMessage(info, info2)
                    }),
                    this.renderGoToHomeButton()
                ]
            })
        });
    }
}
_define_property(Error, "propTypes", {
    code: PropTypes.number
});
export default withStyles(styles)(Error);
